/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/RescheduleAppointment/Content"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<AppointmentAction
  viewPath={`${viewPath}/AppointmentAction`}
 onClick={onClick}
 text="Reschedule Appointment"
/>
{children}
</React.Fragment>)
}